// Whitespace-only formatting: preserve numeric lexemes, key order and escapes.
export function expandJson(text) {
  JSON.parse(text); // Only strict JSON can use this presentation.
  const tokens = text.match(/"(?:\\.|[^"\\])*"|[{}\[\],:]|[^\s{}\[\],:]+/g) || [];
  let depth = 0, out = '';
  const newline = () => { out += '\n' + '  '.repeat(depth); };
  tokens.forEach((token, i) => {
    if (token === '{' || token === '[') {
      out += token;
      depth++;
      if (tokens[i + 1] !== (token === '{' ? '}' : ']')) newline();
    } else if (token === '}' || token === ']') {
      depth--;
      if (tokens[i - 1] !== (token === '}' ? '{' : '[')) newline();
      out += token;
    } else if (token === ',') { out += token; newline(); }
    else if (token === ':') out += ': ';
    else out += token;
  });
  return out;
}
